import React, { Component } from "react";
import pic1 from "../pics_tutorial/ENACTdb_tutorial_1.svg";
import pic2 from "../pics_tutorial/ENACTdb_tutorial_2.svg";
import pic3 from "../pics_tutorial/ENACTdb_tutorial_3.svg";
import pic4 from "../pics_tutorial/ENACTdb_tutorial_4.svg";
import pic5 from "../pics_tutorial/ENACTdb_tutorial_5.svg";
import pic6 from "../pics_tutorial/ENACTdb_tutorial_6.svg";

/*
this tutorial will have brief description of the components and views of page, 
H2: tutorial section
     In Brief:
   database will render gene and its protein coding transctipts (NCBI sourced). Current functionalities of this will includes
       0) showing the nomenclature of the exon and depicting exon s aof varied nature and context in portein transcripts.
       a) showig exon beakup of the portein segments
       b) secondary structure, domain and disorder prediction view along with exon components of proteins. 
       c) showing exonic placeholder comparison of the protein coding transcripts.
   above functionalities will be represented and shown in the following views. 
      a) Exon Detailed view: with focus on the nomenclature per exon view,
      b) exon nightingale component 
      c) 
*/

//by default reference isoform will be renederd by the  
class Tutorial extends Component {

  render() {
    let header2 = "Tutorial Section"
    return (
      <div className="container">
        <div className="jumbotron">
          <h2> {header2} </h2>
          <br></br>
          <p>
            Default home page view will be shown as:
          </p>
          <img
            src={pic1}
            style={{ height: "75%", width: "75%", objectFit: "contain" }}
          />
          <p>
            On entering the gene ID/symbol/name, gene and annotated components will be rendered as below:
          </p>
          <ul>
            <li>
              The result page will be headed by the <b>Gene name</b> and{" "}
              <b>organism</b>. Information about the transcripts is given in the
              caraousal scrollable section and different components of view 1 <b>Exon details</b> are annotated in snaphot below:
              <br />
              <img
                src={pic2}
                style={{ height: "75%", width: "75%", objectFit: "contain" }}
              />
            </li>
            <br /><br />
            <li>
              View components can be easily swicthed by just clicking on the name of the either <b>"Nightingale Tracks"</b> or <b>"Exon Alignment"</b>. The choice of transcripts choosen from carousal view after clicking "
              <i
                className="bi bi-plus-circle-dotted"
                style={{ fontSize: "22px", color: "#00303f" }}
              ></i>" (add) or  "
              <i
                className="bi bi-dash-circle-dotted"
                style={{ fontSize: "22px", color: "#985e6d" }}
              ></i>
              " (to remove) will remain unchanged. The components of <b>Nightingale Tracks</b>  are annotated below.
            </li>
            <br />
            <img
              src={pic3}
              style={{ height: "75%", width: "75%", objectFit: "contain" }}
            />
            <br />
            <br />
            <li>
              The 'datatable' component gives the coordinates and span of domains/secondary structure/ disorder region and exonic regions. Brief display of exon nomenclature in blcoks is also embedded as dropdown.
            </li>
            <br />
            <img
              src={pic4}
              style={{ height: "75%", width: "75%", objectFit: "contain" }}
            />
            <br />
            <br />
            <li>
              Third view <b>'Exon Alignment'</b> details inter transcript comparison, where anchor positions can be referred for comparing/contrasting and possible transcript diffrenecs using informtaion embedded in block 1 and 3 primarily.
            </li>
            <img
              src={pic5}
              style={{ height: "75%", width: "75%", objectFit: "contain" }}
            />
            <br />
            <br />
            <li>
              Another component that we have also provided to facilitate exonic composition of user given protein isoform, that current annotation system lacks is described below.
            </li>
            <img
              src={pic6}
              style={{ height: "75%", width: "75%", objectFit: "contain" }}
            />
            <br />
          </ul>
        </div>
      </div>
    );
  }
}
const headerStyle = {
  background: "Seagreen",
  fontWeight: 500,
  color: "Honeydew",
  padding: "1rem",
  fontFamily: "font-family: Arial, Helvetica, sans-serif"
};
const boldStyle = {
  color: "white",
  fontWeight: "thick"
};

export default Tutorial;
